// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.report-box {
  padding: 8px;
  margin-top: 50px;
  background-color: var(--bg-body);
  color: var(--text-body);
  border-radius: 0;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  -ms-border-radius: 0;
  -o-border-radius: 0;
}

.report-title {
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  align-items: center;
}

.report-name {
  height: 43px;
  font-size: 24px;
}

.deposit-page {
  width: 100%;
  margin: 0 auto;
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  min-height: 100vh;
  padding: 10px;
}

.deposit-page h4 {
  font-weight: bold;
  font-size: 18px;
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
.deposit-page h4 span {
  max-width: calc(100% - 30px);
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
}
.deposit-page h5 {
  font-weight: normal;
  font-size: 18px;
}

.deposit-page .deposit-form {
  padding: 10px;
  border-radius: 12px;
}

.deposit-page .deposit-form .form-group.depo-amount {
  display: flex;
  height: 46px;
  padding: 0 5px;
  margin-right: 0;
  border-radius: 0;
  position: relative;
  background-color: #222;
  color: #eee;
}

.deposit-page .deposit-form .form-group.depo-amount .form-control {
  border: 0;
  box-shadow: none;
  height: 100%;
  background-color: transparent;
  color: var(--text-sidebar);
}

.deposit-page .deposit-form .deposit-minus,
.deposit-page .deposit-form .deposit-plus {
  background-color: transparent;
  border: 0;
  color: var(--text-sidebar);
}

.deposit-page .deposit-form .error {
  position: absolute;
  bottom: -18px;
  font-size: 14px;
  color: red;
  line-height: 1;
}

.deposit-page .deposit-form .btn-add-container {
  height: 46px;
  display: flex;
  align-items: center;
}

.deposit-page .deposit-form .btn-add-container .btn-add {
  padding: 5px 12px;
  font-size: 14px;
  font-weight: bold;
  box-shadow: 0 0 1px !important;
}

.deposit-page .deposit-form .btn-add-container .btn-add:hover {
  color: #fff;
}

.deposit-page .deposit-form .btn-add-container .btn-add:not(:last-child) {
  margin-right: 5px;
}

.deposit-page .payment-ions-container .payment-icons {
    width: calc(30% - 11px);
      margin-right: 30px;
  position: relative;
  background-color: transparent;
  /* background-image: url("../img/payment/pattern1.png"); */
  background-position: center;
  background-size: cover;
  color: var(--text-body);
}
.deposit-page .payment-ions-container .payment-icons .glass {
  background: rgba(144, 144, 144, 0.2);
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
  backdrop-filter: blur(7px);
  -webkit-backdrop-filter: blur(7px);
  border: 1px solid rgba(144, 144, 144, 0.18);
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  content: '';
  z-index: 10;
}
.deposit-page .payment-ions-container .payment-icons .content {
  z-index: 100;
  width: 100%;
}
.deposit-page .payment-ions-container .payment-icons:nth-child(4n) {
  margin-right: 0;
}

.deposit-page .deposit-options {
  padding: 0 10px;
  position: relative;
  margin-bottom: 0;
  width: 100%;
  padding-bottom: 5px;
  /* background-color: #fff; */
  /* align-items: center;
    justify-content: center; */
  /* height: calc(100% - 64px); */
  /* display: flex; */
}

.deposit-page .deposit-options a {
  font-weight: bold;
  color: var(--text-body);
  opacity: 0.9;
}

.deposit-page .deposit-options .form-group {
  min-width: 150px;
  width: auto;
}

.deposit-page .deposit-options .btn {
  height: 46px;
}

.deposit-page .deposit-options > .row {
  position: relative;
  margin-bottom: 10px;
  margin-top: 0;
}
/* .deposit-page .payment-ions-container .payment-icons::before {
    background-image: url("../img/payment-bg.png");
    background-position: bottom right;
    position: absolute;
    content: "";
    z-index: 1;
    background-size: contain;
    height: 160px;
    width: 160px;
    background-repeat: no-repeat;
    right: 0;
    top: 0;
} */

.deposit-page .payment-icons:first-child {
  /* background: #fff; */
  /* border: 3px solid #4b4747; */
}

.deposit-page .payment-icons.whatsapp-box,
.withdraw-request .deposit-page .payment-icons.whatsapp-box {
  /* background-image: url('../img/payment2.png'); */
  background-size: contain;
  background-repeat: no-repeat;
  background-position: bottom;
  background-color: #d6d6d6;
  color: #000;
  min-height: 250px;
}

.withdraw-request .deposit-page .payment-icons.whatsapp-box {
  width: 100%;
  padding: 0;
  margin-top: 0;
  margin-bottom: 0;
  min-height: 240px;
}

.withdraw-request .deposit-options .button {
  background: #0f5f8f !important;
  color: #fff !important;
}

.payment-ions-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  position: relative;
  margin-top: 0;
  margin-bottom: 0;
}

.deposit-page .payment-icons {
  margin-top: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  background: transparent;
  /* border: 3px solid #4b4747; */
  margin-bottom: 10px;
  position: relative;
  align-items: flex-start;
  align-content: flex-start;
}

.deposit-page .payment-ions-container::after {
  /* position: absolute;
    content: "";
    height: 1px;
    width: 70%;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    -webkit-transform: translateX(-50%);
    -moz-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    -o-transform: translateX(-50%); */
}

.bank-detail img {
  height: 90px;
  background-color: #fff;
}

.deposit-page .payment-icons:last-child:after {
  /* display: none; */
}

.deposit-page .payment-icons .payment-icon-box-container {
  padding: 1px;
  width: 25%;
  flex: 1 1 auto;
  max-width: 25%;
}

.deposit-page .payment-icons .payment-icon-box-container .payment-icon-box {
  padding: 15px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #444;
  color: #ddd;
  cursor: pointer;
}

.deposit-page .payment-icons .payment-icon-box-container .payment-icon-box.active {
  background-color: #222;
  color: #eee;
}

.deposit-page .payment-icons .payment-icon-box-container .payment-icon-box img {
  height: 35px;
}

.deposit-page .payment-icons .payment-icon-box-container .payment-icon-box h4 {
  font-size: 18px;
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 0;
}

.deposit-page .payment-icons .payment-icon-box-container .payment-icon-box h4 .fa-info-circle {
  border: 0;
}

.payment-icons.auto-pay .auto-pay-btn {
  display: flex;
  justify-content: end;
  padding: 8px;
}
.payment-icons.auto-pay .crypto-detail {
  padding: 0 5px;
}
.payment-icons.auto-pay .deposit-options p {
  color: #ddd;
}
.deposit-page .deposit-options {
  padding: 0 10px;
  position: relative;
  margin-bottom: 0;
  width: 100%;
  padding-bottom: 5px;
  /* background-color: #fff; */
  /* align-items: center;
    justify-content: center; */
  /* height: calc(100% - 64px); */
  /* display: flex; */
}

.deposit-page .deposit-options a {
  font-weight: bold;
  color: var(--text-body);
  opacity: 0.9;
}

.deposit-page .deposit-options .form-group {
  min-width: 150px;
  width: auto;
}

.deposit-page .deposit-options .btn {
  height: 46px;
}

.deposit-page .deposit-options > .row {
  position: relative;
  margin-bottom: 10px;
  margin-top: 0;
}

/* .deposit-page .deposit-options>.row::after {
    position: absolute;
    content: "";
    height: 1px;
    width: 95%;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    -webkit-transform: translateX(-50%);
    -moz-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    -o-transform: translateX(-50%);
} */

.deposit-page .deposit-options > .row:last-child:after {
  display: none;
}

.deposit-page .deposit-options .bank-detail {
  background: transparent;
  padding: 0 5px;
  /* border: 1px solid var(--text-body); */
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.deposit-page .deposit-options .bank-detail::-webkit-scrollbar {
  width: 8px;
}

.deposit-page .deposit-options .bank-detail::-webkit-scrollbar-track {
  background: #000000;
}

.deposit-page .deposit-options .bank-detail::-webkit-scrollbar-thumb {
  background-color: #333333;
}

/* .deposit-page .deposit-options .bank-detail.qr-code {
    display: flex;
    justify-content: space-between;
} */

.payment-icons-title {
  padding: 10px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}

.payment-icons-title p {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  width: 100%;
  margin-bottom: 0;
  color: var(--text-body);
  opacity: 0.9;
}

.payment-icons-title h3 {
  margin-bottom: 0;
  font-size: 16px;
  font-weight: bold;
}

.deposit-page .deposit-options .payment-detail-box {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
}

.deposit-page .deposit-options .payment-detail-box span {
  max-width: 100%;
  opacity: 0.9;
}

.deposit-page .deposit-options .form-control {
  padding: 10px;
  border-radius: 0;
  margin-top: 10px;
  width: 100%;
  border: 0;
  height: 46px;
}
.deposit-page .deposit-options .crypto-icons {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}
.deposit-page .deposit-options .crypto-icons .crypto-btn img {
  height: 48px;
}
.deposit-page .deposit-options .crypto-icons .crypto-btn {
  width: calc(50% - 5px);
  height: auto;
  cursor: pointer;
  display: flex;
  justify-content: center;
}
.deposit-page .deposit-options .crypto-icons .crypto-btn.disabled {
  cursor: not-allowed;
}

.deposit-page .upload-ss {
  color: #000;
  width: 48%;
  padding: 5px;
  text-align: center;
  border: 1px dashed #ccc;
  height: 50px;
  min-height: 50px;
  display: flex;
  align-items: center;
}

.deposit-page .upload-ss label {
  margin: 0;
  width: 100%;
  cursor: pointer;
  color: var(--text-body);
  opacity: 0.9;
  font-size: 10px;
}

.deposit-page .verify-ss {
  width: 48%;
  height: 50px;
  min-height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed;
  position: relative;
}

.deposit-page .verify-ss img {
  max-height: 100%;
}

.deposit-page .remove-ss {
  position: absolute;
  right: -12px;
  top: -12px;
  font-size: 24px;
  z-index: 1000;
  background: #fff;
  height: 24px;
  width: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: 1px solid #333;
  color: #333;
  cursor: pointer;
}

.deposit-page .payment-icons.crypto-icons-box {
  padding: 0;
  border: 0;
  box-shadow: none !important;
  position: relative;
}

.deposit-page .payment-icons.crypto-icons-box:before {
  position: absolute;
  content: '';
  background-color: #666;
  height: 1px;
  width: 70%;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  -moz-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  -o-transform: translateX(-50%);
}

.deposit-page .payment-icons.crypto-icons-box .payment-icon-box-container {
  width: 100%;
  max-width: 100%;
}

.deposit-page .payment-icons.crypto-icons-box .payment-icon-box-container .payment-icon-box {
  flex-direction: row;
  justify-content: space-between;
  box-shadow: 0 3px 8px #4d4b4b !important;
  background: transparent;
  border: 3px solid #4b4747;
  margin-bottom: 30px;
}

.deposit-page .crypto-icons-box .crypto-icons {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 10px;
}

.deposit-page .crypto-icons-box .crypto-icons .btn {
  background: 0 0;
  border: 0;
  padding: 0;
}

.deposit-page .crypto-icons-box .crypto-icons img {
  height: 50px;
  margin-right: 10px;
}

.deposit-page .crypto-icons-box .crypto-icons .btn:disabled {
  cursor: not-allowed;
}

.deposit-page .payment-icon-box-container .btn-primary,
.deposit-options .btn-primary {
  width: 150px;
}

.deposit-page .upi-barcode img {
  background-color: #fff;
}

.payment-pay-now {
  width: 48%;
  background: var(--bg-success);
  color: var(--text-white);
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  align-content: center;
}
.payment-pay-now > div,
.payment-pay-now > small {
  line-height: 1;
}
.payment-pay-now > small {
  margin-top: 3px;
}
.deposit-page .upload-ss.pay-disable label {
  cursor: not-allowed;
}
.payment-pay-now.pay-disable {
  cursor: not-allowed;
  background: var(--theme1-bg);
  color: var(--secondary-color);
}

.payment-pay-now .desktop-pay-now {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 3px 10px;
  position: relative;
}

.payment-pay-now .desktop-pay-now > div {
  display: flex;
  justify-content: center;
  width: 100%;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}

.payment-pay-now .desktop-pay-now > div > span:first-child {
  text-transform: uppercase;
  font-weight: bold;
  font-size: 18px;
}

.payment-rules {
  color: var(--text-body) !important;
  font-size: 20px;
  border: 0;
}
.payment-disable {
  position: relative;
}

.payment-disable::after {
  position: absolute;
  left: 0;
  top: 0;
  content: '';
  width: 100%;
  height: 100%;
  background-color: #000000bd;
}

.payment-disable::before {
  background: rgba(255, 255, 255, 0.2);
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  content: '';
  z-index: 10;
}

.qr-code {
  position: relative;
  text-align: center;
  width: 100%;
}

.qr-code img {
  width: 100%;
}
.wd-100p{
  width: 100px;
}
.form-check-input{
  margin-left: 0px;
}
.form-check-label {
  margin-bottom: 0;
  padding-left: 20px;
}
.payment-detail-box{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.whatsapp-box {
  background: linear-gradient(135deg, #25d366 0%, #128c7e 100%);
  border: 2px solid #25d366;
}

.whatsapp-box:hover {
  background: linear-gradient(135deg, #128c7e 0%, #075e54 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(37, 211, 102, 0.3);
}

.input-group-text {
  background-color: #25d366;
  color: white;
  border: 1px solid #25d366;
  font-weight: bold;
}

.gap-2 {
  gap: 0.5rem;
}

.deposit-page .card {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border: none;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  margin-bottom: 15px;
}

.deposit-page .card-header {
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  color: white;
  border: none;
  border-radius: 15px 15px 0 0;
  padding: 12px 20px;
}

.deposit-page .add-new-detail {
  padding: 10px;
  margin-bottom: 10px;
}

.deposit-page .add-new-detail:last-child {
  margin-bottom: 0;
}

.deposit-page .payment-icons-title {
  background: linear-gradient(135deg, #ecf0f1 0%, #bdc3c7 100%);
  border-radius: 12px;
  padding: 8px 15px;
  margin-bottom: 10px;
  border: 1px solid #bdc3c7;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.deposit-page .payment-icons-title h3 {
  color: #2c3e50;
  font-weight: 700;
  margin: 0;
}

.deposit-page .btn.btn-primary {
  background: linear-gradient(135deg, #3498db 0%, #2980b9 100%) !important;
  border: none;
  border-radius: 10px;
  padding: 6px 15px;
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(52, 152, 219, 0.3);
  height: 35px;
}

.deposit-page .btn.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(52, 152, 219, 0.4);
  background: linear-gradient(135deg, #2980b9 0%, #3498db 100%) !important;
}

.deposit-page .bank-box {
  background: linear-gradient(135deg, #ffffff 0%, #f5f6fa 100%);
  border: 2px solid #e1e8ed;
  border-radius: 12px;
  padding: 10px;
  margin-bottom: 10px;
  transition: all 0.3s ease;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
}

.deposit-page .bank-box:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  border-color: #3498db;
}

.deposit-page .form-control {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border: 2px solid #e1e8ed;
  border-radius: 10px;
  transition: all 0.3s ease;
  padding: 8px 15px;
  height: 40px;
}

.deposit-page .form-control:focus {
  border-color: #3498db;
  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.1);
  background: #ffffff;
}

.deposit-page .btn.bg-danger {
  background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%) !important;
  border: none;
  border-radius: 10px;
  padding: 8px 20px;
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
  box-shadow: 0 6px 20px rgba(231, 76, 60, 0.3);
  height: 40px;
}

.deposit-page .btn.bg-danger:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(231, 76, 60, 0.4);
  background: linear-gradient(135deg, #c0392b 0%, #e74c3c 100%) !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/withdraw/withdraw.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB;EAChB,gCAAgC;EAChC,uBAAuB;EACvB,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,6DAA6D;EAC7D,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;AACA;EACE,4BAA4B;EAC5B,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;;EAEE,6BAA6B;EAC7B,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;IACI,uBAAuB;MACrB,kBAAkB;EACtB,kBAAkB;EAClB,6BAA6B;EAC7B,0DAA0D;EAC1D,2BAA2B;EAC3B,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,oCAAoC;EACpC,gDAAgD;EAChD,0BAA0B;EAC1B,kCAAkC;EAClC,2CAA2C;EAC3C,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,YAAY;EACZ,WAAW;EACX,WAAW;EACX,WAAW;AACb;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,4BAA4B;EAC5B;8BAC4B;EAC5B,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;AACf;AACA;;;;;;;;;;;;GAYG;;AAEH;EACE,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;;EAEE,kDAAkD;EAClD,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;EAC3B,yBAAyB;EACzB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,aAAa;EACb,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;EACvB,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE;;;;;;;;;;qCAUmC;AACrC;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,cAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,4BAA4B;EAC5B;8BAC4B;EAC5B,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;AACf;;AAEA;;;;;;;;;;;;GAYG;;AAEH;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,wCAAwC;EACxC,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;GAGG;;AAEH;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,YAAY;AACd;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;AACA;EACE,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,WAAW;EACX,UAAU;EACV,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,mCAAmC;EACnC,gCAAgC;EAChC,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,wCAAwC;EACxC,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,6BAA6B;EAC7B,wBAAwB;EACxB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,SAAS;AACX;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,gDAAgD;EAChD,0BAA0B;EAC1B,kCAAkC;EAClC,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,YAAY;EACZ,WAAW;EACX,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,wEAAwE;EACxE,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,8CAA8C;EAC9C,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;EAC9C,wEAAwE;AAC1E;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,wEAAwE;EACxE,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,6CAA6C;EAC7C,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;EAC7C,wEAAwE;AAC1E","sourcesContent":[".report-box {\n  padding: 8px;\n  margin-top: 50px;\n  background-color: var(--bg-body);\n  color: var(--text-body);\n  border-radius: 0;\n  -webkit-border-radius: 0;\n  -moz-border-radius: 0;\n  -ms-border-radius: 0;\n  -o-border-radius: 0;\n}\n\n.report-title {\n  display: flex;\n  display: -webkit-flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.report-name {\n  height: 43px;\n  font-size: 24px;\n}\n\n.deposit-page {\n  width: 100%;\n  margin: 0 auto;\n  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);\n  min-height: 100vh;\n  padding: 10px;\n}\n\n.deposit-page h4 {\n  font-weight: bold;\n  font-size: 18px;\n  position: relative;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n.deposit-page h4 span {\n  max-width: calc(100% - 30px);\n  width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: inline-block;\n}\n.deposit-page h5 {\n  font-weight: normal;\n  font-size: 18px;\n}\n\n.deposit-page .deposit-form {\n  padding: 10px;\n  border-radius: 12px;\n}\n\n.deposit-page .deposit-form .form-group.depo-amount {\n  display: flex;\n  height: 46px;\n  padding: 0 5px;\n  margin-right: 0;\n  border-radius: 0;\n  position: relative;\n  background-color: #222;\n  color: #eee;\n}\n\n.deposit-page .deposit-form .form-group.depo-amount .form-control {\n  border: 0;\n  box-shadow: none;\n  height: 100%;\n  background-color: transparent;\n  color: var(--text-sidebar);\n}\n\n.deposit-page .deposit-form .deposit-minus,\n.deposit-page .deposit-form .deposit-plus {\n  background-color: transparent;\n  border: 0;\n  color: var(--text-sidebar);\n}\n\n.deposit-page .deposit-form .error {\n  position: absolute;\n  bottom: -18px;\n  font-size: 14px;\n  color: red;\n  line-height: 1;\n}\n\n.deposit-page .deposit-form .btn-add-container {\n  height: 46px;\n  display: flex;\n  align-items: center;\n}\n\n.deposit-page .deposit-form .btn-add-container .btn-add {\n  padding: 5px 12px;\n  font-size: 14px;\n  font-weight: bold;\n  box-shadow: 0 0 1px !important;\n}\n\n.deposit-page .deposit-form .btn-add-container .btn-add:hover {\n  color: #fff;\n}\n\n.deposit-page .deposit-form .btn-add-container .btn-add:not(:last-child) {\n  margin-right: 5px;\n}\n\n.deposit-page .payment-ions-container .payment-icons {\n    width: calc(30% - 11px);\n      margin-right: 30px;\n  position: relative;\n  background-color: transparent;\n  /* background-image: url(\"../img/payment/pattern1.png\"); */\n  background-position: center;\n  background-size: cover;\n  color: var(--text-body);\n}\n.deposit-page .payment-ions-container .payment-icons .glass {\n  background: rgba(144, 144, 144, 0.2);\n  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);\n  backdrop-filter: blur(7px);\n  -webkit-backdrop-filter: blur(7px);\n  border: 1px solid rgba(144, 144, 144, 0.18);\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n  width: 100%;\n  content: '';\n  z-index: 10;\n}\n.deposit-page .payment-ions-container .payment-icons .content {\n  z-index: 100;\n  width: 100%;\n}\n.deposit-page .payment-ions-container .payment-icons:nth-child(4n) {\n  margin-right: 0;\n}\n\n.deposit-page .deposit-options {\n  padding: 0 10px;\n  position: relative;\n  margin-bottom: 0;\n  width: 100%;\n  padding-bottom: 5px;\n  /* background-color: #fff; */\n  /* align-items: center;\n    justify-content: center; */\n  /* height: calc(100% - 64px); */\n  /* display: flex; */\n}\n\n.deposit-page .deposit-options a {\n  font-weight: bold;\n  color: var(--text-body);\n  opacity: 0.9;\n}\n\n.deposit-page .deposit-options .form-group {\n  min-width: 150px;\n  width: auto;\n}\n\n.deposit-page .deposit-options .btn {\n  height: 46px;\n}\n\n.deposit-page .deposit-options > .row {\n  position: relative;\n  margin-bottom: 10px;\n  margin-top: 0;\n}\n/* .deposit-page .payment-ions-container .payment-icons::before {\n    background-image: url(\"../img/payment-bg.png\");\n    background-position: bottom right;\n    position: absolute;\n    content: \"\";\n    z-index: 1;\n    background-size: contain;\n    height: 160px;\n    width: 160px;\n    background-repeat: no-repeat;\n    right: 0;\n    top: 0;\n} */\n\n.deposit-page .payment-icons:first-child {\n  /* background: #fff; */\n  /* border: 3px solid #4b4747; */\n}\n\n.deposit-page .payment-icons.whatsapp-box,\n.withdraw-request .deposit-page .payment-icons.whatsapp-box {\n  /* background-image: url('../img/payment2.png'); */\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: bottom;\n  background-color: #d6d6d6;\n  color: #000;\n  min-height: 250px;\n}\n\n.withdraw-request .deposit-page .payment-icons.whatsapp-box {\n  width: 100%;\n  padding: 0;\n  margin-top: 0;\n  margin-bottom: 0;\n  min-height: 240px;\n}\n\n.withdraw-request .deposit-options .button {\n  background: #0f5f8f !important;\n  color: #fff !important;\n}\n\n.payment-ions-container {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  position: relative;\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\n.deposit-page .payment-icons {\n  margin-top: 0;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  background: transparent;\n  /* border: 3px solid #4b4747; */\n  margin-bottom: 10px;\n  position: relative;\n  align-items: flex-start;\n  align-content: flex-start;\n}\n\n.deposit-page .payment-ions-container::after {\n  /* position: absolute;\n    content: \"\";\n    height: 1px;\n    width: 70%;\n    bottom: -10px;\n    left: 50%;\n    transform: translateX(-50%);\n    -webkit-transform: translateX(-50%);\n    -moz-transform: translateX(-50%);\n    -ms-transform: translateX(-50%);\n    -o-transform: translateX(-50%); */\n}\n\n.bank-detail img {\n  height: 90px;\n  background-color: #fff;\n}\n\n.deposit-page .payment-icons:last-child:after {\n  /* display: none; */\n}\n\n.deposit-page .payment-icons .payment-icon-box-container {\n  padding: 1px;\n  width: 25%;\n  flex: 1 auto;\n  max-width: 25%;\n}\n\n.deposit-page .payment-icons .payment-icon-box-container .payment-icon-box {\n  padding: 15px;\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background-color: #444;\n  color: #ddd;\n  cursor: pointer;\n}\n\n.deposit-page .payment-icons .payment-icon-box-container .payment-icon-box.active {\n  background-color: #222;\n  color: #eee;\n}\n\n.deposit-page .payment-icons .payment-icon-box-container .payment-icon-box img {\n  height: 35px;\n}\n\n.deposit-page .payment-icons .payment-icon-box-container .payment-icon-box h4 {\n  font-size: 18px;\n  font-weight: bold;\n  margin-top: 10px;\n  margin-bottom: 0;\n}\n\n.deposit-page .payment-icons .payment-icon-box-container .payment-icon-box h4 .fa-info-circle {\n  border: 0;\n}\n\n.payment-icons.auto-pay .auto-pay-btn {\n  display: flex;\n  justify-content: end;\n  padding: 8px;\n}\n.payment-icons.auto-pay .crypto-detail {\n  padding: 0 5px;\n}\n.payment-icons.auto-pay .deposit-options p {\n  color: #ddd;\n}\n.deposit-page .deposit-options {\n  padding: 0 10px;\n  position: relative;\n  margin-bottom: 0;\n  width: 100%;\n  padding-bottom: 5px;\n  /* background-color: #fff; */\n  /* align-items: center;\n    justify-content: center; */\n  /* height: calc(100% - 64px); */\n  /* display: flex; */\n}\n\n.deposit-page .deposit-options a {\n  font-weight: bold;\n  color: var(--text-body);\n  opacity: 0.9;\n}\n\n.deposit-page .deposit-options .form-group {\n  min-width: 150px;\n  width: auto;\n}\n\n.deposit-page .deposit-options .btn {\n  height: 46px;\n}\n\n.deposit-page .deposit-options > .row {\n  position: relative;\n  margin-bottom: 10px;\n  margin-top: 0;\n}\n\n/* .deposit-page .deposit-options>.row::after {\n    position: absolute;\n    content: \"\";\n    height: 1px;\n    width: 95%;\n    bottom: -10px;\n    left: 50%;\n    transform: translateX(-50%);\n    -webkit-transform: translateX(-50%);\n    -moz-transform: translateX(-50%);\n    -ms-transform: translateX(-50%);\n    -o-transform: translateX(-50%);\n} */\n\n.deposit-page .deposit-options > .row:last-child:after {\n  display: none;\n}\n\n.deposit-page .deposit-options .bank-detail {\n  background: transparent;\n  padding: 0 5px;\n  /* border: 1px solid var(--text-body); */\n  overflow-y: auto;\n  overflow-x: hidden;\n  scrollbar-width: thin;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n.deposit-page .deposit-options .bank-detail::-webkit-scrollbar {\n  width: 8px;\n}\n\n.deposit-page .deposit-options .bank-detail::-webkit-scrollbar-track {\n  background: #000000;\n}\n\n.deposit-page .deposit-options .bank-detail::-webkit-scrollbar-thumb {\n  background-color: #333333;\n}\n\n/* .deposit-page .deposit-options .bank-detail.qr-code {\n    display: flex;\n    justify-content: space-between;\n} */\n\n.payment-icons-title {\n  padding: 10px;\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.payment-icons-title p {\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: block;\n  width: 100%;\n  margin-bottom: 0;\n  color: var(--text-body);\n  opacity: 0.9;\n}\n\n.payment-icons-title h3 {\n  margin-bottom: 0;\n  font-size: 16px;\n  font-weight: bold;\n}\n\n.deposit-page .deposit-options .payment-detail-box {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  width: 100%;\n}\n\n.deposit-page .deposit-options .payment-detail-box span {\n  max-width: 100%;\n  opacity: 0.9;\n}\n\n.deposit-page .deposit-options .form-control {\n  padding: 10px;\n  border-radius: 0;\n  margin-top: 10px;\n  width: 100%;\n  border: 0;\n  height: 46px;\n}\n.deposit-page .deposit-options .crypto-icons {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n}\n.deposit-page .deposit-options .crypto-icons .crypto-btn img {\n  height: 48px;\n}\n.deposit-page .deposit-options .crypto-icons .crypto-btn {\n  width: calc(50% - 5px);\n  height: auto;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n}\n.deposit-page .deposit-options .crypto-icons .crypto-btn.disabled {\n  cursor: not-allowed;\n}\n\n.deposit-page .upload-ss {\n  color: #000;\n  width: 48%;\n  padding: 5px;\n  text-align: center;\n  border: 1px dashed #ccc;\n  height: 50px;\n  min-height: 50px;\n  display: flex;\n  align-items: center;\n}\n\n.deposit-page .upload-ss label {\n  margin: 0;\n  width: 100%;\n  cursor: pointer;\n  color: var(--text-body);\n  opacity: 0.9;\n  font-size: 10px;\n}\n\n.deposit-page .verify-ss {\n  width: 48%;\n  height: 50px;\n  min-height: 50px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 1px dashed;\n  position: relative;\n}\n\n.deposit-page .verify-ss img {\n  max-height: 100%;\n}\n\n.deposit-page .remove-ss {\n  position: absolute;\n  right: -12px;\n  top: -12px;\n  font-size: 24px;\n  z-index: 1000;\n  background: #fff;\n  height: 24px;\n  width: 24px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n  border: 1px solid #333;\n  color: #333;\n  cursor: pointer;\n}\n\n.deposit-page .payment-icons.crypto-icons-box {\n  padding: 0;\n  border: 0;\n  box-shadow: none !important;\n  position: relative;\n}\n\n.deposit-page .payment-icons.crypto-icons-box:before {\n  position: absolute;\n  content: '';\n  background-color: #666;\n  height: 1px;\n  width: 70%;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  -webkit-transform: translateX(-50%);\n  -moz-transform: translateX(-50%);\n  -ms-transform: translateX(-50%);\n  -o-transform: translateX(-50%);\n}\n\n.deposit-page .payment-icons.crypto-icons-box .payment-icon-box-container {\n  width: 100%;\n  max-width: 100%;\n}\n\n.deposit-page .payment-icons.crypto-icons-box .payment-icon-box-container .payment-icon-box {\n  flex-direction: row;\n  justify-content: space-between;\n  box-shadow: 0 3px 8px #4d4b4b !important;\n  background: transparent;\n  border: 3px solid #4b4747;\n  margin-bottom: 30px;\n}\n\n.deposit-page .crypto-icons-box .crypto-icons {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  margin-top: 10px;\n}\n\n.deposit-page .crypto-icons-box .crypto-icons .btn {\n  background: 0 0;\n  border: 0;\n  padding: 0;\n}\n\n.deposit-page .crypto-icons-box .crypto-icons img {\n  height: 50px;\n  margin-right: 10px;\n}\n\n.deposit-page .crypto-icons-box .crypto-icons .btn:disabled {\n  cursor: not-allowed;\n}\n\n.deposit-page .payment-icon-box-container .btn-primary,\n.deposit-options .btn-primary {\n  width: 150px;\n}\n\n.deposit-page .upi-barcode img {\n  background-color: #fff;\n}\n\n.payment-pay-now {\n  width: 48%;\n  background: var(--bg-success);\n  color: var(--text-white);\n  height: 50px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  align-content: center;\n}\n.payment-pay-now > div,\n.payment-pay-now > small {\n  line-height: 1;\n}\n.payment-pay-now > small {\n  margin-top: 3px;\n}\n.deposit-page .upload-ss.pay-disable label {\n  cursor: not-allowed;\n}\n.payment-pay-now.pay-disable {\n  cursor: not-allowed;\n  background: var(--theme1-bg);\n  color: var(--secondary-color);\n}\n\n.payment-pay-now .desktop-pay-now {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 3px 10px;\n  position: relative;\n}\n\n.payment-pay-now .desktop-pay-now > div {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  flex-wrap: wrap;\n  flex-direction: column;\n  align-items: center;\n  cursor: pointer;\n}\n\n.payment-pay-now .desktop-pay-now > div > span:first-child {\n  text-transform: uppercase;\n  font-weight: bold;\n  font-size: 18px;\n}\n\n.payment-rules {\n  color: var(--text-body) !important;\n  font-size: 20px;\n  border: 0;\n}\n.payment-disable {\n  position: relative;\n}\n\n.payment-disable::after {\n  position: absolute;\n  left: 0;\n  top: 0;\n  content: '';\n  width: 100%;\n  height: 100%;\n  background-color: #000000bd;\n}\n\n.payment-disable::before {\n  background: rgba(255, 255, 255, 0.2);\n  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);\n  backdrop-filter: blur(2px);\n  -webkit-backdrop-filter: blur(2px);\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n  width: 100%;\n  content: '';\n  z-index: 10;\n}\n\n.qr-code {\n  position: relative;\n  text-align: center;\n  width: 100%;\n}\n\n.qr-code img {\n  width: 100%;\n}\n.wd-100p{\n  width: 100px;\n}\n.form-check-input{\n  margin-left: 0px;\n}\n.form-check-label {\n  margin-bottom: 0;\n  padding-left: 20px;\n}\n.payment-detail-box{\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.whatsapp-box {\n  background: linear-gradient(135deg, #25d366 0%, #128c7e 100%);\n  border: 2px solid #25d366;\n}\n\n.whatsapp-box:hover {\n  background: linear-gradient(135deg, #128c7e 0%, #075e54 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(37, 211, 102, 0.3);\n}\n\n.input-group-text {\n  background-color: #25d366;\n  color: white;\n  border: 1px solid #25d366;\n  font-weight: bold;\n}\n\n.gap-2 {\n  gap: 0.5rem;\n}\n\n.deposit-page .card {\n  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n  border: none;\n  border-radius: 15px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n  margin-bottom: 15px;\n}\n\n.deposit-page .card-header {\n  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);\n  color: white;\n  border: none;\n  border-radius: 15px 15px 0 0;\n  padding: 12px 20px;\n}\n\n.deposit-page .add-new-detail {\n  padding: 10px;\n  margin-bottom: 10px;\n}\n\n.deposit-page .add-new-detail:last-child {\n  margin-bottom: 0;\n}\n\n.deposit-page .payment-icons-title {\n  background: linear-gradient(135deg, #ecf0f1 0%, #bdc3c7 100%);\n  border-radius: 12px;\n  padding: 8px 15px;\n  margin-bottom: 10px;\n  border: 1px solid #bdc3c7;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n}\n\n.deposit-page .payment-icons-title h3 {\n  color: #2c3e50;\n  font-weight: 700;\n  margin: 0;\n}\n\n.deposit-page .btn.btn-primary {\n  background: linear-gradient(135deg, #3498db 0%, #2980b9 100%) !important;\n  border: none;\n  border-radius: 10px;\n  padding: 6px 15px;\n  font-weight: 600;\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(52, 152, 219, 0.3);\n  height: 35px;\n}\n\n.deposit-page .btn.btn-primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(52, 152, 219, 0.4);\n  background: linear-gradient(135deg, #2980b9 0%, #3498db 100%) !important;\n}\n\n.deposit-page .bank-box {\n  background: linear-gradient(135deg, #ffffff 0%, #f5f6fa 100%);\n  border: 2px solid #e1e8ed;\n  border-radius: 12px;\n  padding: 10px;\n  margin-bottom: 10px;\n  transition: all 0.3s ease;\n  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);\n}\n\n.deposit-page .bank-box:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);\n  border-color: #3498db;\n}\n\n.deposit-page .form-control {\n  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);\n  border: 2px solid #e1e8ed;\n  border-radius: 10px;\n  transition: all 0.3s ease;\n  padding: 8px 15px;\n  height: 40px;\n}\n\n.deposit-page .form-control:focus {\n  border-color: #3498db;\n  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.1);\n  background: #ffffff;\n}\n\n.deposit-page .btn.bg-danger {\n  background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%) !important;\n  border: none;\n  border-radius: 10px;\n  padding: 8px 20px;\n  font-weight: 600;\n  font-size: 14px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  transition: all 0.3s ease;\n  box-shadow: 0 6px 20px rgba(231, 76, 60, 0.3);\n  height: 40px;\n}\n\n.deposit-page .btn.bg-danger:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(231, 76, 60, 0.4);\n  background: linear-gradient(135deg, #c0392b 0%, #e74c3c 100%) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
